import dayjs from '../../../utils/dayjs.util';
import calendar from 'dayjs/plugin/calendar';
import React, { useEffect, useState } from 'react';

import { Order } from '../../../requests/caipirinha-api/interfaces/order.interface';
import Button from '../../../components/Button';
import Input from '../../../components/Input';
import { ExpirationDateText } from '../styles';

dayjs.extend(calendar);

interface Props {
  order?: Order;
}

const PixCode: React.FC<Props> = ({ order }) => {
  const [copyPixCodeName, setCopyPixCodeName] = useState('Copiar código Pix');
  const [code, setCode] = useState<string>();
  const [expirationDate, setExpirationDate] = useState<string>();

  useEffect(() => {
    if (order?.details.pix) {
      const { pix } = order.details;
      setCode(pix.code);
      setExpirationDate(pix.expirationDate);
    }
  }, [order]);

  const handleCopyPixKey = () => {
    navigator.clipboard.writeText(code as string);
    setCopyPixCodeName('Copiado!');
  };

  const formatExpireDate = () =>
    dayjs(expirationDate)
      .locale('pt-br')
      .calendar()
      .toLocaleLowerCase();

  return (
    <>
      <Input
        readOnly
        placeholder="Código Pix"
        type="text"
        id="pixKey"
        name="pixKey"
        value={code || 'Código Pix indisponível'}
      />

      {code && (
        <>
          <Button
            data-cy='copy-pix-button'
            type="button"
            onClick={handleCopyPixKey}
            theme="SUCCESS"
            marginTop={16}
          >
            {copyPixCodeName}
          </Button>

          <ExpirationDateText data-cy='expiration-date-text' variant="smallBold">
            O código é válido até {formatExpireDate()}.
          </ExpirationDateText>
        </>
      )}
    </>
  );
};

export default PixCode;
